export default __webpack_public_path__ + "static/Grzegorczyk-1fdb3f7964e5d116446bdb099da897e6.jpg";